import { WprBaseViewInfo } from '../../wpr-framework/view/WprBaseViewInfo';
import { ScrollView } from './ScrollView';

/**
 * ビュー基本情報１
 */
export class BaseWindowView extends WprBaseViewInfo {
	// private 変数  ------------------------------------------------------------
	private m_ScrollView = new ScrollView();
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(name: string) {
		super(name);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * ウインドウリサイズ通知
	 * @param width 幅
	 * @param height 高さ
	 */
	public onResizeWindow(width: number, height: number): void {
		this.m_ScrollView.onResizeWindow(width, height);
	}

	/**
	 * ウインドウスクロール通知
	 * @param pageXOffset Xオフセット
	 * @param pageYOffset Yオフセット
	 */
	public onScrollWindow(pageXOffset: number, pageYOffset: number): void {
		this.m_ScrollView.onScrollWindow(this, pageXOffset, pageYOffset);
	}
	// --------------------------------------------------------------------------

	// protected メソッド  ------------------------------------------------------
	/**
	 * 先頭へスクロール
	 */
	protected scrollToTop(): void {
		this.m_ScrollView.scrollToTop();
	}
	// --------------------------------------------------------------------------
}
